// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.good {
  background: lightgreen;
}

.TotalCurrent span {
  padding-left: 2em;
  padding-right: 2em;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.Totals {
  clear: both;
  text-align: left;
  padding-top: 20px;
}
.Totals label {
  font-weight: bold;
}

.Pumps {
  overflow: auto;
  white-space: nowrap;
}
.Pumps .Pump {
  border: 1px solid black;
  border-radius: 10px;
  margin: 1px;
  padding-top: 2px;
  padding-bottom: 2px;
}
.Pumps .Pump div {
  height: 2em;
  line-height: 2em;
}
.Pumps .Pump.Vertical {
  float: left;
  width: 100px;
}
.Pumps .Pump.Vertical label {
  font-weight: bold;
}
.Pumps .Pump.error {
  border: 1px solid red !important;
  background-color: pink !important;
}
.Pumps .Pump.enabled {
  border: 1px solid green;
  background-color: lightgreen;
}
.Pumps .Pump.Header {
  text-align: right;
  padding-right: 5px;
  border: none;
}
.Pumps .Pump input {
  text-align: center;
}

.System {
  overflow: auto;
  white-space: nowrap;
}
.System .Item {
  border: 1px solid black;
  border-radius: 10px;
  margin: 1px;
  padding-top: 2px;
  padding-bottom: 2px;
}
.System .Item div {
  height: 2em;
  line-height: 2em;
}
.System .Item.enabled {
  border: 1px solid green;
  background-color: lightgreen;
}
.System .Item.error {
  border: 1px solid red !important;
  background-color: pink !important;
}
.System .Item input {
  text-align: center;
}
.System .Vertical.Double {
  width: 204px;
}
.System .Vertical.Double .Split {
  display: inline-block;
  width: 100px;
  height: 100%;
}
.System .Vertical.Double .Split.Left {
  text-align: right;
  margin-right: 2px;
}
.System .Vertical.Double .Split.Right {
  text-align: left;
  margin-left: 2px;
}
.System .Vertical.Double .Split div {
  height: 2em;
  line-height: 2em;
}
.System .Vertical {
  float: left;
  width: 100px;
}
.System .Vertical label {
  font-weight: bold;
}
.System .Vertical.Right {
  float: right !important;
}
.System .Header {
  text-align: right;
  padding-right: 5px;
  border: none;
}

.ProductList {
  border: 1px solid black;
  border-radius: 10px;
  margin-top: 1px;
  margin-left: 106px;
  margin-bottom: 2px;
  padding: 5px;
}

.Controls {
  overflow: auto;
  white-space: nowrap;
}

#header {
  height: 50px;
  clear: both;
}
#header h1 {
  line-height: 50px;
  text-align: center;
}

#footer {
  height: 50px;
  padding: 5px;
  font-size: 75%;
  text-align: center;
  clear: both;
}

body {
  width: 1147px;
  color: black;
  background-color: white;
}

.recommended {
  background-color: green !important;
}

.warning {
  background-color: yellow !important;
}

.error {
  background-color: red !important;
}`, "",{"version":3,"sources":["webpack://./src/css/App.scss"],"names":[],"mappings":"AAQA;EACE,kBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,cAAA;AAPF;;AAUA;EACE;IACE,uBAAA;EAPF;EASA;IACE,yBAAA;EAPF;AACF;AASA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AAPF;AAQE;EACE,iBAAA;AANJ;;AAUA;EACE,cAAA;EACA,mBAAA;AAPF;AASE;EACE,uBAAA;EACA,mBAAA;EACA,WAzDW;EA0DX,gBAAA;EACA,mBAAA;AAPJ;AAQI;EACE,WAAA;EACA,gBAAA;AANN;AAQI;EACE,WAAA;EACA,YAjEO;AA2Db;AAOM;EACE,iBAAA;AALR;AAQI;EACE,gCAAA;EACA,iCAAA;AANN;AAQI;EACE,uBAAA;EACA,4BAAA;AANN;AAQI;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;AANN;AAQI;EACE,kBAAA;AANN;;AAWA;EACE,cAAA;EACA,mBAAA;AARF;AAUE;EACE,uBAAA;EACA,mBAAA;EACA,WAjGW;EAkGX,gBAAA;EACA,mBAAA;AARJ;AASI;EACE,WAAA;EACA,gBAAA;AAPN;AASI;EACE,uBAAA;EACA,4BAAA;AAPN;AASI;EACE,gCAAA;EACA,iCAAA;AAPN;AASI;EACE,kBAAA;AAPN;AAUE;EACE,YAlHgB;AA0GpB;AASI;EACE,qBAAA;EACA,YAvHO;EAwHP,YAAA;AAPN;AAQM;EACE,iBAAA;EACA,iBAAA;AANR;AAQM;EACE,gBAAA;EACA,gBAAA;AANR;AAQM;EACE,WAAA;EACA,gBAAA;AANR;AAUE;EACE,WAAA;EACA,YAzIS;AAiIb;AASI;EACE,iBAAA;AAPN;AASI;EACE,uBAAA;AAPN;AAUE;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;AARJ;;AAYA;EACE,uBAAA;EACA,mBAAA;EACA,eA5Ja;EA6Jb,kBAAA;EACA,kBAAA;EACA,YAAA;AATF;;AAYA;EACE,cAAA;EACA,mBAAA;AATF;;AAYA;EACE,YAAA;EAKA,WAAA;AAbF;AASE;EACE,iBAAA;EACA,kBAAA;AAPJ;;AAYA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AATF;;AAYA;EACI,aAAA;EACA,YA7LS;EA8LT,uBA7LoB;AAoLxB;;AAYA;EACE,kCAAA;AATF;;AAYA;EACE,mCAAA;AATF;;AAYA;EACE,gCAAA;AATF","sourcesContent":["$base-color: black;\n$base-background-color: white;\n$border-width: 1px;\n$margin-width: 1px;\n$pump-width: 100px;\n$pump-total-width: $pump-width + (2 * ($border-width + $margin-width));\n$pump-double-width: ($pump-width + $border-width + $margin-width) * 2;\n\n.App {\n  text-align: center;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.good {\n  background: lightgreen;\n}\n\n.TotalCurrent span {\n  padding-left: 2em;\n  padding-right: 2em;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.Totals {\n  clear: both;\n  text-align: left;\n  padding-top: 20px;\n  label {\n    font-weight: bold;\n  }\n}\n\n.Pumps {\n  overflow: auto;\n  white-space: nowrap;\n\n  .Pump {\n    border: $border-width solid black;\n    border-radius: 10px;\n    margin: $margin-width;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    div {\n      height: 2em;\n      line-height: 2em;\n    }\n    &.Vertical {\n      float: left;\n      width: $pump-width;\n      label {\n        font-weight: bold;\n      }\n    }\n    &.error {\n      border: $border-width solid red !important;\n      background-color: pink !important;\n    }\n    &.enabled {\n      border: $border-width solid green;\n      background-color: lightgreen;\n    }\n    &.Header {\n      text-align: right;\n      padding-right: 5px;\n      border: none;\n    }\n    input { \n      text-align: center; \n    }\n  }\n}\n\n.System {\n  overflow: auto;\n  white-space: nowrap;\n\n  .Item {\n    border: $border-width solid black;\n    border-radius: 10px;\n    margin: $margin-width;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    div {\n      height: 2em;\n      line-height: 2em;\n    }\n    &.enabled {\n      border: $border-width solid green;\n      background-color: lightgreen;\n    }\n    &.error {\n      border: $border-width solid red !important;\n      background-color: pink !important;\n    }\n    input { \n      text-align: center; \n    }\n  }\n  .Vertical.Double {\n    width: $pump-double-width;\n    .Split {\n      display: inline-block;\n      width: $pump-width;\n      height: 100%;\n      &.Left {\n        text-align: right;\n        margin-right: $border-width + $margin-width;\n      }\n      &.Right {\n        text-align: left;\n        margin-left: $border-width + $margin-width;\n      }\n      div {\n        height: 2em;\n        line-height: 2em;\n      }\n    }\n  }\n  .Vertical {\n    float: left;\n    width: $pump-width;\n    label {\n      font-weight: bold;\n    }\n    &.Right {\n      float: right !important;\n    }\n  }\n  .Header {\n    text-align: right;\n    padding-right: 5px;\n    border: none;\n  }\n}\n\n.ProductList {\n  border: $border-width solid black;\n  border-radius: 10px;\n  margin-top: $margin-width;\n  margin-left: $pump-total-width + ($margin-width*2);\n  margin-bottom: $margin-width * 2;\n  padding: 5px;\n}\n\n.Controls {\n  overflow: auto;\n  white-space: nowrap;\n}\n\n#header {\n  height: 50px;\n  h1 {\n    line-height: 50px;\n    text-align: center;\n  }\n  clear: both;\n}\n\n#footer {\n  height: 50px;\n  padding: 5px;\n  font-size: 75%;\n  text-align: center;\n  clear: both;\n}\n\nbody {\n    width: ($pump-total-width * 11) + $border-width + ($margin-width * 2);\n    color: $base-color;\n    background-color: $base-background-color;\n  }\n\n.recommended {\n  background-color: green !important;\n}\n\n.warning {\n  background-color: yellow !important;\n}\n\n.error {\n  background-color: red !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
